import  axios from 'axios';
import { message } from 'ant-design-vue'
import qs from 'qs'
import router from '../router'

const errorCode ={
    SUCCESS:'ROOT-0000',
    BUSINESS_ERROR:'ROOT-3000',
    SYSTEM_ERROR:'ROOT-5000',
    NOT_LOGIN_USER:'ROOT-4000',
    NOT_LOGIN_ADMIN:'ROOT-4001',
}

function dealResponse(res,func){
      if(errorCode.SUCCESS == res.data.code){
        func(res.data)
    }else if(errorCode.BUSINESS_ERROR == res.data.code){
        message.error(res.data.message);
    }else if(errorCode.SYSTEM_ERROR == res.data.code){
        message.error('系统错误');
    }else if(errorCode.NOT_LOGIN_USER == res.data.code){
        router.push("/login");
    }else if(errorCode.NOT_LOGIN_ADMIN == res.data.code){
        message.error('管理员未登录');
    }else{
      message.error('系统错误');
    }
}


let ax = axios.create({ 
    // timeout: 1000,
    headers: {'X-Custom-Header': 'foobar'}
  });



  let req = {
    get:function(url,params,func){
      axios.get(url,params)
      .then(res => {
        dealResponse(res,func);
      })
      .catch(err => {
       
      })
    },
    post:function(url,params,func){
      let that = this;
      axios.post(url,params)
      .then(res => {
        dealResponse(res,func);
      })
      .catch(err => {
       
      })
    },

    formDataPost:function(url,params,func){
      let that = this;
      axios.post(url,qs.stringify(params), {headers: {'Content-Type':'application/x-www-form-urlencoded'}})
      .then(res => {
        dealResponse(res,func);
      })
      .catch(err => {
       
      })
    }
  }
export default req;